import * as React from 'react';
import { ToggleButton as ToggleButtonComponent } from '../ToggleButton';

interface IToggleButtonProps {
  closedText: string;
  opened: boolean;
  onClick(): void;
}

export function ToggleButton({ closedText, opened, onClick }: IToggleButtonProps) {
  return (
    <ToggleButtonComponent isOpened={opened} onClick={onClick}>
      {opened ? 'Свернуть' : closedText}
    </ToggleButtonComponent>
  );
}
